import React from 'react';
import AudioPodcast from './component/audio';
import Header from './component/header';
import RemoteAPI from './component/remote';
import Youtube from './component/youtube';

function RootComponent() {

    let score = 88

    const welcome = () => {
        return "Welcome to Mars!"
    }

    return (
        <div style={{backgroundColor:"pink"}}>
            <div>
                <h1>I am a root component!</h1>
                <h2>I am the JSX</h2>
                <h3>Score: {score}</h3>
                <h3>Message: {welcome()}</h3>
            </div>
            <div>
                <h1>I am a sibling div</h1>
            </div>
            <div style={{
                            border:"2px solid red", 
                            padding:"10px",
                            margin:"0px 0px 20px 0px"
                        }}>
                <Header></Header>
            </div>
        
            <div style={{
                border:"2px solid blue",
                padding:"10px",
                //margin:"20px 0px 0px  0px"
            }}>
                <Youtube></Youtube>
            </div>
            <div>
                <AudioPodcast></AudioPodcast>
            </div>
            <div style={{
                border:"2px solid orange",
                padding:"10px",
                marginTop:"10px" 
            }}>
                <RemoteAPI></RemoteAPI>
            </div>

        </div>

    );
}

export default RootComponent;
